"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooManyOperationsBeaconError = void 0;
const __1 = require("..");
class TooManyOperationsBeaconError extends __1.BeaconError {
    constructor() {
        super(__1.BeaconErrorType.TOO_MANY_OPERATIONS, 'The request contains too many transactions. Please include fewer operations and try again.');
        this.name = 'TooManyOperationsBeaconError';
        this.title = 'Too Many Operations';
    }
}
exports.TooManyOperationsBeaconError = TooManyOperationsBeaconError;
//# sourceMappingURL=TooManyOperationsBeaconError.js.map